module.exports = __webpack_public_path__ + "img/30 armo.e09b0b86.jpg";